import { render } from "./AlmRightSidebarInfo.vue?vue&type=template&id=8087eb90&scoped=true&ts=true"
import script from "./AlmRightSidebarInfo.vue?vue&type=script&lang=ts"
export * from "./AlmRightSidebarInfo.vue?vue&type=script&lang=ts"

import "./AlmRightSidebarInfo.vue?vue&type=style&index=0&id=8087eb90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8087eb90"]])

export default __exports__